export const API_URL = process.env.REACT_APP_API_END_POINT ? `${process.env.REACT_APP_API_END_POINT}/` : "https://devapi.soildoctor.in/";
